import Vue from 'vue'
import { formatVal, hasAccess } from './utils'

function emitValue(val, el, vNode) {
    const instance = vNode.componentInstance

    if (instance) {
        instance.$emit('input', val)
    } else {
        el.value = val
        el.dispatchEvent(new Event('input'))
    }
}

Vue.directive('inputLimit', {
    inserted(el, binding, vNode) {
        const arg = binding.arg === undefined ? 'string' : binding.arg 
        let { max, min, toFixed, maxLength } = binding.value || {}

        function setVal(e) {
            let value = e.target.value

            // 小数失去焦点容错
            if(e.type === 'focusout' && arg === 'float') {
                value = parseFloat(value)
            }
            value = formatVal(value, { type: arg, max, min, toFixed, maxLength })
            emitValue(value, el, vNode)
        }

        el.addEventListener('keyup', setVal)
        el.addEventListener('focusout', setVal)
    }
})

Vue.directive('access', function (el, binding, vnode) {
    let { modifiers: btnState, arg, rawName, value } = binding
    let access
    let haveAccess = true
    let { idx } = value || {}

    if(Array.isArray(arg)) {
        access = arg
    }else {
        let btnsAccess = vnode.context.$route.meta.btnsAccess
        if(btnsAccess) {
            access = btnsAccess[arg]
        }
    }

    if(btnState.hide === undefined && btnState.disabled === undefined) {
        btnState.hide = true
    }

    if(Array.isArray(access)) {
        if(idx) {
            access = access[idx]
            haveAccess = hasAccess(access)
        }else {
            haveAccess = Boolean(access.find(id => hasAccess(id)))
        }
    }else {
        haveAccess = hasAccess(access)
    }

    if(!haveAccess) {
        if(btnState.hide) {
            vnode.context.$nextTick(() => {
                el.style.display = 'none'
            })
        }else if(btnState.disabled) {
            if(vnode.componentOptions.tag === 'el-button') {
                vnode.componentInstance.disabled = true
            }else {
                throw `${rawName}: 仅el-button组件支持disabled属性`
            }
        }
    }else {
        if(btnState.hide) {
            el.style.display = ''
        }
    }
}
)

